export class Pager {
    pages: number
    current: number
    limit: number
    items: number

    constructor() {
        this.pages = 0
        this.current = 1
        this.limit = 20
        this.items = 0
    }
}
